import { Button, Modal, message } from 'antd';
import { useState, useEffect } from 'react';
import AddChannelForm from './AddChannelForm';
import { editChannel } from '../services/channel';

const EditChannelPopup = ({ 
  channelData, 
  onClose, 
  onUpdateSuccess,
  visible 
}) => {
  const [formData, setFormData] = useState({
    channelID: '',
    channelName: '',
    sport: ''
  });
  const [loading, setLoading] = useState(false);

  // Update formData when channelData changes
  useEffect(() => {
    if (channelData) {
      setFormData({
        channelID: channelData.channelID || '',
        channelName: channelData.channelName || '',
        sport: channelData.sports || ''
      });
    }
  }, [channelData]);

  const handleUpdate = async () => {
    try {
      setLoading(true);
      await editChannel(channelData._id, {
        channelID: formData.channelID,
        channelName: formData.channelName,
        sports: formData.sport,
        type: channelData.type
      });
      
      message.success('Channel updated successfully');
      onUpdateSuccess();
      onClose();
    } catch (error) {
      message.error(error.message || 'Failed to update channel');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal 
      title="Edit Channel"
      width={600}
      open={visible}
      onCancel={onClose}
      footer={null}
      destroyOnClose
    >
      <AddChannelForm 
        isEditing={true}
        channelId={formData.channelID}
        setChannelId={(val) => setFormData({...formData, channelID: val})}
        channelName={formData.channelName}
        setChannelName={(val) => setFormData({...formData, channelName: val})}
        sport={formData.sport}
        setSport={(val) => setFormData({...formData, sport: val})}
      />
      <div className="flex justify-end gap-2 mt-5">
        <Button 
          onClick={onClose}
          className="bg-[#F2F4F7] font-medium text-small"
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          loading={loading}
          onClick={handleUpdate}
          className="bg-[#E61F26] text-white hover:bg-[#C91A20] font-medium text-small"
          disabled={!formData.channelID || !formData.channelName || !formData.sport}
        >
          Update Channel
        </Button>
      </div>        
    </Modal>
  );
};

export default EditChannelPopup;